// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"855":"f44c444c","878":"a5fe1d90","944":"cb072fe2"}[chunkId] + ".chunk.js";
};